import React from "react";

export const AnalysisIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.2406 7.84442H25.0372V31.44C25.0375 33.9447 22.9996 35.9824 20.4949 35.9824C17.99 35.9824 15.9523 33.9447 15.9523 31.4401L15.9525 7.84443H15.7496C15.3355 7.84443 15 7.509 15 7.09487V4.74956C15 4.33544 15.3355 4 15.7496 4H25.2406C25.6547 4 25.9901 4.33543 25.9901 4.74956V7.09494C25.9901 7.509 25.6545 7.84442 25.2406 7.84442ZM23.538 7.84442H17.4516V19.0483C19.8937 18.6265 20.9544 19.4615 21.4147 20.2933C21.7553 20.908 22.4687 21.1511 23.5381 21.0189L23.538 7.84442ZM17.4516 20.574V31.4399C17.4516 33.1179 18.8167 34.483 20.4947 34.483C22.1729 34.483 23.5381 33.1179 23.5381 31.4399L23.5381 22.527C21.7739 22.6949 20.6765 22.0553 20.1032 21.0197C19.6956 20.2832 18.4332 20.3719 17.4516 20.574ZM16.499 6.34517H24.4909V5.49913H16.499V6.34517Z"
      fill="currentColor"
    />
  </svg>
);
